var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memberShip"},[_c('div',{staticClass:"shipContent content_area"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }